export const white = "#ffffff";
